import { useQuery } from 'data-fetching-client';
import { OWNERS_QUERY, OWNER_BY_ID_QUERY } from '../unified-attendee-select/query/ownersQuery';
import { formatOwners } from '../unified-attendee-select/utils/formatUtils';
import { useCallback, useState } from 'react';
export const useOwnersSearch = ({
  searchQuery,
  client,
  count,
  prefetch = false,
  minimumQueryLength = 3
}) => {
  const [currOffset, setCurrOffset] = useState(0);
  const getShouldSkip = () => {
    if (prefetch && searchQuery.length === 0) {
      return false;
    }
    return !(searchQuery.length >= minimumQueryLength);
  };
  const shouldSkip = getShouldSkip();
  const queryOptions = {
    fetchPolicy: 'cache-and-network',
    skip: shouldSkip,
    variables: {
      ownerInput: searchQuery,
      limit: count,
      offset: currOffset
    }
  };
  const {
    data: ownersData,
    refetch: refetchOwners,
    error: ownersError,
    loading: loadingOwners
  } = useQuery(OWNERS_QUERY, client ? Object.assign({
    client
  }, queryOptions) : queryOptions);
  const results = ownersData && ownersData.owners.results.map(formatOwners);
  const nextOffset = ownersData && ownersData.owners.offset || 0;
  const hasMore = ownersData && ownersData.owners.hasMore || false;
  const loadMore = useCallback(() => {
    if (currOffset !== nextOffset) {
      setCurrOffset(nextOffset);
    }
  }, [currOffset, nextOffset]);
  return {
    ownersData: results,
    ownersError,
    loadingOwners,
    hasMore,
    refetchOwners,
    loadMore
  };
};
export const useOwnersByIdSearch = ({
  ownerIds,
  client
}) => {
  const shouldSkip = !(ownerIds.length >= 1);
  const queryOptions = {
    fetchPolicy: 'cache-and-network',
    skip: shouldSkip,
    variables: {
      ownerIds
    }
  };
  const {
    data: ownersData,
    refetch: refetchOwnersById,
    error: ownersByIdError,
    loading: loadingOwnersById
  } = useQuery(OWNER_BY_ID_QUERY, client ? Object.assign({
    client
  }, queryOptions) : queryOptions);
  const results = ownersData && ownersData.owners.map(formatOwners) || [];
  return {
    ownersByIdData: results,
    refetchOwners: refetchOwnersById,
    ownersError: ownersByIdError,
    loadingOwners: loadingOwnersById
  };
};